const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "side_blocks": {
    "fr": [
      "42040905"
    ]
  },
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "display_contact": false,
  "fb_display": false,
  "mapbox_token": "pk.eyJ1Ijoia3dwMjAyMSIsImEiOiJja202aHkxc20wb2RnMnh1aTA4YTM0OTMwIn0.7Us7PsbmVW1knkEwde0htw",
  "last_news_label": {
    "fr": "Actualités"
  },
  "search_title": {
    "fr": "Recherche"
  },
  "twitter_display": false,
  "api_url": "https://api-v2.mobireport.fr",
  "search_button_label": {
    "fr": "Rechercher"
  },
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "contact_label": {
    "fr": ""
  },
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "website_name": "Express A14",
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "time_format": {
    "fr": "HH:mm"
  },
  "contact_phone_number": {
    "fr": ""
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "primary_color": {
    "red": 0,
    "blue": 125,
    "alpha": 255,
    "green": 95
  },
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "secondary_color": {
    "red": 255,
    "blue": 255,
    "alpha": 255,
    "green": 255
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "alt_text": {
    "fr": "Renseignements : "
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "subsidiary_logo": {
    "path": "/56511/1633702345-logoa14express.svg",
    "format": "svg",
    "size": 10972,
    "alt": "Express A14",
    "title": null,
    "width": 453,
    "height": 88
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "back_to_home_title": {
    "fr": "Express A14 – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "search_token": "8d0a878279304985cc55d0d41bdfc3",
  "google_tag_manager_id": "GTM-MKBZQMK",
  "loader": {
    "path": "/56511/1627293859-loaderkeolis.gif",
    "format": "gif",
    "size": 228385,
    "alt": "Loader de chargement",
    "title": "Loader",
    "width": 1772,
    "height": 1772
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [],
  "updated_at": "2021-12-01T18:36:47.337+01:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://qksakwpexpewstatweb.z6.web.core.windows.net/",
  "readOnlyApi": "e87f2ba0b5e82b33cb76ae0d00033c"
}